import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getEstablishments = () => {
    return request({
        url: namespace + "/establishments",
        method: "get",
    });
};

export const getEstablishment = (_id) => {
    return request({
        url: namespace + "/establishment/" + _id,
        method: "get",
    });
};

export const createEstablishment = (payload) => {
    return request({
        url: namespace + "/establishment",
        data: payload,
        method: "post",
    });
};

export const updateEstablishment = (establishment_id, payload) => {
    return request({
        url: namespace + "/establishment/" + establishment_id,
        data: payload,
        method: "post",
    });
};

export const linkUserEstablishment = (user_id, establishment_id, action = "LINK") => {
    return request({
        url: namespace + "/establishment/" + action + "/" + user_id,
        method: "post",
        data: {
            user_id,
            establishment_id,
            action,
        },
    });
};
